export default __webpack_public_path__ + "95c6b792c672d0e8c96738f9ffd6b7f3.svg";